import { useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import useFormik from 'hooks/useFormik';
import FormInput from 'components/Form/Input';
import FormInputRow from 'components/Form/InputRow';
import ActionRow from 'components/ActionRow';
import Loader from 'components/Loaders/Loader';
import { Snackbar } from 'components/Snackbars';
import authService from 'store/auth/service';
import { validationSchema } from './validationSchema';

import styles from './styles.module.scss';
import { ReactComponent as IconGroupCovered } from 'assets/images/group-covered.svg';
import { ContentBox } from '../../../components/ContentBox';
import { CompanyLogo } from '../../../components/CompanyLogo';
import ButtonWithArrowIcon from '../../../components/Buttons/ButtonWithArrowIcon';
import { CompanyContext } from '../../../index';

export const RegistrationByInviteLinkPage = () => {
  const { t } = useTranslation();
  const company = useContext(CompanyContext);
  const [isSuccess, setIsSuccess] = useState<null | boolean>(false);
  const [isCreatedByFleet, setIsCreatedByFleet] = useState<null | boolean>(
    false
  );

  const urlSearchParams = new URLSearchParams(window.location.search);

  const [register, { isLoading }] =
    authService.endpoints.registerByInvite.useMutation();

  const { getFieldProps, getFieldErrorProp, handleSubmit } = useFormik({
    initialValues: {
      firstName: '',
      lastName: '',
      email: '',
    },
    validationSchema,
    onSubmit(value) {
      register({
        firstName: value.firstName,
        lastName: value.lastName,
        email: value.email,
        code: urlSearchParams.get('id') || '-',
      }).then(
        //eslint-disable-next-line
        (el: any) => {
          if (el.error) return <Snackbar message={'Invalid Credentials'} />;
          setIsSuccess(true);
          if (el?.data?.createdByFleet) {
            setIsCreatedByFleet(true);
          }
        }
      );
    },
  });

  return (
    <div className={styles.root}>
      <ContentBox className={styles.content}>
        <CompanyLogo src={company.logo} responsive={true} />
        {!isSuccess ? (
          <form onSubmit={handleSubmit} className={styles.form}>
            <FormInputRow
              className={styles.inputRow}
              required
              {...getFieldErrorProp('firstName')}
            >
              <FormInput
                {...getFieldProps('firstName')}
                placeholder={
                  t('RegistrationByInviteLinkPage.label.firstName') || ''
                }
              />
            </FormInputRow>
            <FormInputRow
              className={styles.inputRow}
              required
              {...getFieldErrorProp('lastName')}
            >
              <FormInput
                {...getFieldProps('lastName')}
                placeholder={
                  t('RegistrationByInviteLinkPage.label.lastName') || ''
                }
              />
            </FormInputRow>
            <FormInputRow
              className={styles.inputRow}
              required
              {...getFieldErrorProp('email')}
            >
              <FormInput
                {...getFieldProps('email')}
                placeholder={
                  t('RegistrationByInviteLinkPage.label.email') || ''
                }
              />
            </FormInputRow>
            <ActionRow style="space-between">
              <ButtonWithArrowIcon type="submit" disabled={isLoading}>
                {t('RegistrationByInviteLinkPage.btn.submit')}
              </ButtonWithArrowIcon>
            </ActionRow>
            {isLoading && <Loader />}
          </form>
        ) : (
          <div className={styles.success}>
            {!isCreatedByFleet ? (
              <div>
                <IconGroupCovered className={styles.icon} />
                <h1>Confirm your email address.</h1>
                <div>
                  We sent an email to you. Please confirm your email address by
                  clicking the link we just sent to your inbox
                </div>
              </div>
            ) : (
              <div>
                <IconGroupCovered className={styles.icon} />
                <h1>Your account was created by a fleet account.</h1>
                <div>
                  Please use your Haul-fleet account (email address and
                  password) to log in.
                </div>
              </div>
            )}
          </div>
        )}
      </ContentBox>
    </div>
  );
};
